var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaggageCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 24C9.35457 24 10.25 23.1046 10.25 22C10.25 20.8954 9.35457 20 8.25 20C7.14543 20 6.25 20.8954 6.25 22C6.25 23.1046 7.14543 24 8.25 24Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 24C20.3546 24 21.25 23.1046 21.25 22C21.25 20.8954 20.3546 20 19.25 20C18.1454 20 17.25 20.8954 17.25 22C17.25 23.1046 18.1454 24 19.25 24Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.25H6C5.44772 17.25 5 16.8023 5 16.25V4.50801C5.00542 2.8974 4.09485 1.42374 2.652 0.708007L1.452 0.108007C0.957157 -0.140245 0.354756 0.0596596 0.106504 0.554507C-0.141748 1.04935 0.0581566 1.65175 0.553004 1.90001L1.753 2.50001C2.51756 2.8768 3.00124 3.65565 3 4.50801V16.25C3 17.9069 4.34315 19.25 6 19.25H23C23.5523 19.25 24 18.8023 24 18.25C24 17.6977 23.5523 17.25 23 17.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 15.25C18.5 15.5262 18.2761 15.75 18 15.75H11C10.7239 15.75 10.5 15.5262 10.5 15.25V5.00101C10.5 5.00101 11.109 1.50101 14.5 1.50101C16.5278 1.53218 18.2282 3.04123 18.5 5.05101V15.25ZM14.5 3.50093C13.933 3.50093 13.3932 3.74376 13.017 4.168V4.16701C12.8857 4.31403 12.8531 4.52446 12.9336 4.70435C13.0142 4.88423 13.1929 5.00002 13.39 5H15.61C15.8067 4.99966 15.9849 4.88403 16.0654 4.70454C16.1459 4.52507 16.1136 4.31508 15.983 4.168C15.6068 3.74376 15.067 3.50093 14.5 3.50093Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.75H21C21.8284 15.75 22.5 15.0784 22.5 14.25V6.5C22.5 5.67157 21.8284 5 21 5H20.5C20.2239 5 20 5.22386 20 5.5V15.25C20 15.5261 20.2239 15.75 20.5 15.75Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.75H8.5C8.77614 15.75 9 15.5261 9 15.25V5.5C9 5.22386 8.77614 5 8.5 5H8C7.17157 5 6.5 5.67157 6.5 6.5V14.25C6.5 15.0784 7.17157 15.75 8 15.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggageCart);
export default __webpack_public_path__ + "static/media/baggageCart.071dbb0f.svg";
export { ForwardRef as ReactComponent };